import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NAV_TYPE } from '@shared/models';
import { LayoutService } from '@shared/services/layout.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { RoutingService } from '@shared/services/routing.service';
import { Location } from '@angular/common';
import { ContactTracingService } from '../../../contact-tracing/services/contact-tracing.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer-step-nav',
  templateUrl: './footer-step-nav.component.html',
  styleUrls: ['./footer-step-nav.component.scss']
})
export class FooterStepNavComponent implements OnInit, OnDestroy {
  private destroySubject = new Subject();
  @Input() loading: boolean = false;
  @Input() actionType: NAV_TYPE = NAV_TYPE.NEXT;
  @Input() actionText: string = 'Next';
  @Output() onAction: EventEmitter<any> = new EventEmitter<any>();
  NAV_TYPE = NAV_TYPE;

  btnTextTranslates = {
    [NAV_TYPE.NEXT]: 'nextStr',
    [NAV_TYPE.GO]: 'getStartedStr',
    [NAV_TYPE.BACK]: 'backStr',
    [NAV_TYPE.CONFIRM_AND_GO]: 'confirmAndGetStartedStr',
  }

  constructor(private layoutService: LayoutService,
              private routingService: RoutingService,
              private location: Location,
              private router: Router,
              private contactTracingService: ContactTracingService) { }

  ngOnInit(): void {
    this.layoutService.config
      .pipe(
        filter( x => !!x),
        takeUntil(this.destroySubject)
      )
      .subscribe((config: any) => {
        this.actionType = config.footer.navType;
        this.actionText = config.footer.btnText;
      });

    this.layoutService.loading$
      .pipe(takeUntil(this.destroySubject))
      .subscribe(loading => {
        this.loading = loading;
      });
  }

  onActionClick() {
    this.layoutService.footerAction({
      type: this.actionType
    })

    this.onAction.emit({
      type: this.actionType
    })

    if (this.actionType === NAV_TYPE.BACK) {
      if (this.contactTracingService.isContactTracing) {
        this.router.navigateByUrl(this.contactTracingService.baseUrl);
      } else {
        this.routingService.redirectToLco();
      }
    }
  }

  ngOnDestroy() {
    this.destroySubject.next();
    this.destroySubject.complete();
  }
}
